export const OPEN_MATRIZ_ACTION = 'OPEN_MATRIZ_ACTION';
export const OPEN_TALARIS_ACTION = 'OPEN_TALARIS_ACTION';